<div class="sticky-container" [class.toggled]="isMenuToggled">
    <div *ngIf="!isMenuToggled" class="left-bar"></div>
    <list-view #visualisation *ngIf="liste" [liste]="liste" (filterVisibleChange)="onFilterVisibleChange($event)"></list-view>
</div>
